var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFileDone24Line(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8354 8.8349C18.8204 8.7599 18.7954 8.6949 18.7604 8.6299C18.7504 8.6149 18.7454 8.5949 18.7354 8.5799C18.7004 8.5149 18.6554 8.4549 18.6004 8.3999L14.6004 4.3999C14.5454 4.3449 14.4854 4.3049 14.4204 4.2649C14.4054 4.2549 14.3904 4.2499 14.3754 4.2399C14.2604 4.1849 14.1354 4.1499 14.0004 4.1499H7.80039C6.34039 4.1499 5.15039 5.3399 5.15039 6.7999V17.1999C5.15039 18.6599 6.34039 19.8499 7.80039 19.8499H16.2004C17.6604 19.8499 18.8504 18.6599 18.8504 17.1999V8.9999C18.8504 8.9449 18.8454 8.8899 18.8354 8.8349ZM15.9504 8.1499H14.8504V7.0499L15.9504 8.1499ZM16.2004 18.1499H7.80039C7.27539 18.1499 6.85039 17.7249 6.85039 17.1999V6.7999C6.85039 6.2749 7.27539 5.8499 7.80039 5.8499H13.1504V8.3999C13.1504 9.1999 13.8004 9.8499 14.6004 9.8499H17.1504V17.1999C17.1504 17.7249 16.7254 18.1499 16.2004 18.1499Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1254 14.2799L9.62039 12.6549L8.37539 13.8099L10.2654 15.8499C10.4754 16.0799 10.7754 16.2149 11.0854 16.2199C11.0954 16.2199 11.1004 16.2199 11.1104 16.2199C11.4104 16.2199 11.7054 16.0999 11.9204 15.8849L15.5954 12.2249L14.3954 11.0199L11.1204 14.2799H11.1254Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileDone24Line);
export default __webpack_public_path__ + "static/media/icon_file_done_24_line.331e8b40ef6cc8c79cc47eba93e01823.svg";
export { ForwardRef as ReactComponent };